import React from "react";
import NavigationItem from "./NavigationItem";
import { NAVIGATION_DEMO } from "data/navigation";
import { useSelector } from "react-redux";

function Navigation() {
  const subscription = useSelector((state: any) => state.user.subscription);
  const subscriptionStatus = useSelector(
    (state: any) => state.user.subscriptionStatus
  );
  const checkSubs = (item: string) => {
    if (subscriptionStatus === "active" && item === "/member") {
      return false;
    }
    return true;
  };

  return (
    <ul className="nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative">
      {NAVIGATION_DEMO.map((item) =>
        checkSubs(item.href) ? (
          <NavigationItem key={item.id} menuItem={item} />
        ) : null
      )}
    </ul>
  );
}

export default Navigation;
